"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Utility method returning current time.
 * This is a wrapper mainly for mocking purpose during tests.
 */
ngModule.factory("$now", function () {
  return function () {
    return _.now();
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/$now.js
// module id = 2741
// module chunks = 13